export default "/images/stuhmer-logo-white.svg?0f628f1ed9694d60f23d0401b6583ad5";